export class VMModel {
    guacamoleServerUrl: string;
    rdpUri: string;
    isSwitchVm?: boolean;
}
